import React, { JSX, useEffect, useMemo, useState } from "react";
import { Flex, Link, Text, View } from "@adobe/react-spectrum";
import "../style.css";
import "./ChatDetails.css";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/storeConfig";
import { formatLabel } from "../../../utils/utils";
import { useCustomerAttributes } from "../../../hooks/useCustomerAttributes";

interface IChatDetailsProps {
  chatDetail: any;
}

const ChatDetails: React.FC<IChatDetailsProps> = ({ chatDetail }) => {
  const agent = useSelector((state: RootState) => state.agent);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [chatDetailList, setChatDetailList] = useState<any[]>([]);

  const customerAttrs = chatDetail?.customer?.attributes || {};
  const businessAttrs = agent?.businessAttributes || [];

  const { groupedAttributes } = useCustomerAttributes({
    customerAttrs,
    businessAttrs,
    type: "detail",
  });

  const finalArrayToShow = useMemo(() => {
    const final: JSX.Element[] = [];

    groupedAttributes.forEach((group, index) => {
      final.push(
        <Flex
          direction="row"
          justifyContent="space-between"
          key={`chat-detail-row-${index}`}
          width="100%"
          gap={10}
        >
          {group.map((attr, idx) => (
            <Flex
              direction="column"
              marginTop={20}
              width="30%"
              key={`attr-${index}-${idx}`}
            >
              <Text UNSAFE_className="chat-detail-title">
                {attr.attributeName.toLowerCase() === "notes"
                  ? "Transfer Notes"
                  : formatLabel(attr.attributeName)}
              </Text>
              <Text UNSAFE_className="chat-detail-description">
                {customerAttrs[attr.attributeName] || "-"}
              </Text>
            </Flex>
          ))}
        </Flex>
      );
    });

    return final;
  }, [groupedAttributes, customerAttrs]);

  useEffect(() => {
    setChatDetailList(
      showMoreDetails ? finalArrayToShow : finalArrayToShow.slice(0, 2)
    );
  }, [finalArrayToShow, showMoreDetails]);

  const handleShowMoreDetails = () => {
    setShowMoreDetails((prev) => !prev);
  };

  return (
    <View backgroundColor="gray-100" padding="0px 10px">
      <View borderTopWidth="thick" borderTopColor="gray-200">
        <View>{chatDetailList}</View>
        <View paddingY={10}>
          <Link onPress={handleShowMoreDetails}>
            <a href="#" className="chat-view-more chat-detail-description">
              {showMoreDetails ? "View less details" : "View more details"}
            </a>
          </Link>
        </View>
      </View>
    </View>
  );
};

export default ChatDetails;
